import api from '../../api'
// import wsAPI from '../../wsEmpresaAPI'
import { endpoints } from '../../apiCommons'
import localCompany from '../localStorage/localCompany'

// const getBranch = async (sEmpresa) =>{
//   api
//     .get(`${endpoints.branch_office}/${sEmpresa || 0}`)
//     .then((res) => res.data)
//     .catch((error) => console.error(error))}
// const getCostCenter = async (sEmpresa) =>
//   api
//     .get(`${endpoints.cost_center}/${sEmpresa || 0}`)
//     .then((res) => res.data)
//     .catch((error) => console.error(error))

const getEmployees = async () => {
  const { sEmpresa } = localCompany.getCompanyData()
  const token = localStorage.getItem('token')
  return api
    .get(endpoints.company_employees, {
      params: { sEmpresa },
      headers: { token },
    })
    .then((res) => res.data)
    .catch((error) => console.error(error))
}

const getCompanyData = async (sEmpresa) => {
  const token = localStorage.getItem('token')
  return api.get(endpoints.listCompanyData, {
    params: { sEmpresa },
    headers: { token },
  })
}

const companyDetails = () => {
  const { sEmpresa } = localCompany.getCompanyData()

  const token = localStorage.getItem('token')
  return api.get(endpoints.companyDetail, {
    params: {
      sEmpresa,
    },
    headers: { token },
  })
}

const getRechargesToBill = async () => {
  const token = localStorage.getItem('token')

  const { sEmpresa } = localCompany.getCompanyData()
  return api.get(endpoints.rechargesToBill, {
    params: {
      sEmpresa,
    },
    headers: { token },
  })
}

const getHistoryMovements = async () => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.get(endpoints.historyMovements, {
    params: { sEmpresa },
    headers: { token },
  })
}

const getPurchaseOrders = async () => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.get(endpoints.purchaseOrders, {
    params: { sEmpresa },
    headers: { token },
  })
}

const getHistoricMovementByDocument = async (nDocumento) => {
  const token = localStorage.getItem('token')
  return api.get(endpoints.historicMovement, {
    params: {
      nDocumento,
    },
    headers: { token },
  })
}

const getOCById = async (nOC) => {
  const token = localStorage.getItem('token')
  return api.get(endpoints.infoOC, { params: { nOC }, headers: { token } })
}

const getBranchOffices = async () => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.get(endpoints.listBranchOffice, {
    params: {
      sEmpresa,
    },
    headers: {
      token,
    },
  })
}
const branchOfficeById = async (sSucursal) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.get(endpoints.branchOfficeDetail, {
    params: {
      sSucursal,
      sEmpresa,
    },
    headers: { token },
  })
}

const createBranchOffice = async (data) => {
  const token = localStorage.getItem('token')
  return api.post(
    endpoints.createBranchOffice,
    { ...data },
    { headers: { token } },
  )
}
const createMassiveBranchOffice = async (data) => {
  const token = localStorage.getItem('token')
  return api.post(endpoints.createMassiveBranchOffice, data, {
    headers: { token },
  })
}

const validateCreateMassiveBranchOffice = async (data) => {
  const token = localStorage.getItem('token')
  return api.post(endpoints.createMassiveBranchOffice, data, {
    headers: { token },
    params: {
      bSoloValidar: true,
    },
  })
}

const getCostCenters = async () => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.get(endpoints.listCostCenters, {
    params: {
      sEmpresa,
    },
    headers: { token },
  })
}

const getRegions = async () => {
  const token = localStorage.getItem('token')
  return api.get(endpoints.regions, { token })
}

const createCostCenter = async (NombreCetroCosto) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.post(endpoints.newCostCenter, [{ sEmpresa, NombreCetroCosto }], {
    headers: { token },
  })
}
const createMassiveCostCenter = async (data) => {
  const token = localStorage.getItem('token')
  return api.post(endpoints.newCostCenter, data, { headers: { token } })
}

const validateCreateMassiveCostCenter = async (data) => {
  const token = localStorage.getItem('token')
  return api.post(endpoints.newCostCenter, data, {
    headers: { token },
    params: { bSoloValidar: true },
  })
}

const updateCostCenter = async ({ sCentroCosto, sDescripcion }) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.post(
    endpoints.updateCostCenter,
    {
      sEmpresa,
      sCentroCosto,
      sDescripcion,
    },
    { headers: { token } },
  )
}
const deleteCostCenter = async ({ sCentroCosto }) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.delete(endpoints.deleteCostCenter, {
    params: { sEmpresa, sCentroCosto },
    headers: { token },
  })
}
const deleteBranchOffice = async ({ sSucursal }) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.delete(endpoints.deleteBranchOffice, {
    params: { sEmpresa, sSucursal },
    headers: { token },
  })
}
const costCenterDetail = async ({ sCentroCosto }) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.get(endpoints.costCenterDetail, {
    params: { sEmpresa, sCentroCosto },
    headers: { token },
  })
}

const validateCompanyInfo = async () => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  const newCompanyData = await api
    .get(endpoints.validateCompanyData, {
      params: { sEmpresa },
      headers: { token },
    })
    .then((res) => res.data)
  const actualUser = localCompany.getUserData()
  if (actualUser.oEmpresa.length > 0) {
    const newData = {
      ...actualUser,
      oEmpresa: [
        {
          ...actualUser.oEmpresa[0],
          sTipoRecarga: newCompanyData.sTipoRecarga,
        },
      ],
    }
    localCompany.setUserData(newData)
  }
}

const updateBranchOffice = ({
  sSucursal,
  NombreSucursal,
  sDireccion,
  sComuna,
  sRegion,
  sCentroCosto,
  sSucursalPadre,
  InfoContacto,
}) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.post(
    endpoints.updateBranchOffice,
    {
      sEmpresa,
      sSucursal,
      NombreSucursal,
      sDireccion,
      sComuna,
      sRegion,
      sCentroCosto,
      sSucursalPadre,
      InfoContacto,
    },
    { headers: { token } },
  )
}

const getDefaultAlerts = async () => {
  const token = localStorage.getItem('token')
  return api.get(endpoints.defaultAlerts, { headers: { token } })
}
const getActiveAlerts = async () => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.get(endpoints.activeAlerts, {
    headers: { token },
    params: { sEmpresa },
  })
}

const postConfigAutomaticNN = async (bAsociacionNNAutomatica) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.post(
    endpoints.AjustesWebEmpresa,
    {
      bAsociacionNNAutomatica,
      sEmpresa,
    },
    { headers: { token } },
  )
}

const getAutomaticEnroll = async () => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.get(endpoints.getAutomaticEnroll, {
    params: { sEmpresa },
    headers: { token },
  })
}

const configureAlert = ({
  idAlerta,
  sHoraNotificacion = '00:00',
  idOpcionVariableAlerta,
}) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.post(
    endpoints.configureAlert,
    {
      idAlerta,
      sEmpresa,
      sHoraNotificacion,
      idOpcionVariableAlerta,
    },
    {
      headers: {
        token,
      },
    },
  )
}
const updateAlert = ({ idAlertaEmpresa, sEstado, sNuevoEstado }) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.post(
    endpoints.changeAlertState,
    {
      idAlertaEmpresa,
      sEmpresa,
      sEstado,
      sNuevoEstado,
    },
    {
      headers: {
        token,
      },
    },
  )
}

const SendEmailCompanyAdvisor = async (sEmpresa, sAsunto) => {
  const token = localStorage.getItem('token')
  return api.get(endpoints.SendEmailAdvisorCompany, {
    params: {
      sEmpresa,
      sAsunto,
    },
    headers: { token },
  })
}

export default {
  // getBranch,
  // getCostCenter,
  getEmployees,
  getCompanyData,
  companyDetails,
  getRechargesToBill,
  getHistoryMovements,
  getPurchaseOrders,
  getHistoricMovementByDocument,
  getBranchOffices,
  getCostCenters,
  branchOfficeById,
  createBranchOffice,
  getRegions,
  getOCById,
  createCostCenter,
  createMassiveBranchOffice,
  createMassiveCostCenter,
  validateCompanyInfo,
  updateCostCenter,
  deleteCostCenter,
  costCenterDetail,
  updateBranchOffice,
  deleteBranchOffice,
  getDefaultAlerts,
  getActiveAlerts,
  configureAlert,
  postConfigAutomaticNN,
  getAutomaticEnroll,
  updateAlert,
  SendEmailCompanyAdvisor,
  validateCreateMassiveBranchOffice,
  validateCreateMassiveCostCenter,
}
